import { render, staticRenderFns } from "./AddNewCaseView.vue?vue&type=template&id=2224d44c&scoped=true&"
import script from "./AddNewCaseView.vue?vue&type=script&lang=js&"
export * from "./AddNewCaseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2224d44c",
  null
  
)

export default component.exports